<div>
  <mat-icon [svgIcon]="iconName"></mat-icon>
</div>
